(function() {
    function bisSubscribeMarketing(email) {
        const payload = {
            data: {
                type: "subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email.trim()
                            }
                        }
                    },
                    custom_source: "Back in Stock Multi-step"
                },
                relationships: {
                    list: {
                        data: {
                            type: "list",
                            id: "XbFwTY"
                        }
                    }
                }
            }
        };

        return fetch(
            "https://a.klaviyo.com/client/subscriptions?company_id=PzHwHa",
            {
                method: "POST",
                headers: {
                    "revision": "2026-07-15",
                    "accept": "application/vnd.api+json",
                    "content-type": "application/vnd.api+json"
                },
                body: JSON.stringify(payload)
            }
        );
    }

    function bisSubscribe(formData) {
        const email = formData.get("email");
        const variantId = formData.get("bis-variant-id");
        const marketing = formData.has("bis-marketing");

        if(!email || !variantId) return;

        const payload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email.trim()
                            }
                        }
                    },
                    "channels": ["EMAIL"]
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": `$shopify:::$default:::${variantId}`
                        }
                    }
                }
            }
        };

        var requestOptions = {
            method: 'POST',
            headers: {
                revision: '2026-07-15',
                accept: 'application/vnd.api+json',
                'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify(payload)
        };
        
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PzHwHa", requestOptions)
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
        
        if(marketing) {
            bisSubscribeMarketing(email);
        }

        const modalContent = document.querySelector("#back-in-stock .modal__content");
        if(!modalContent) return;

        modalContent.querySelector(":scope > div:first-child").style.display = "none";
        modalContent.querySelector(":scope > div:last-child").style.display = "block";
    }

    function bindEvents() {
        document.addEventListener("submit", function(event) {
            const bisForm = event.target.closest(".bis-modal-form");
            if(!bisForm) return;

            event.preventDefault();
            const emailInput = bisForm.querySelector("#bis-email");
            if(!emailInput) return;

            if(!emailInput.checkValidity()) {
                emailInput.classList.add("bis-invalid");
                return;
            }

            const bisFormData = new FormData(bisForm);
            bisSubscribe(bisFormData);
        });


        document.addEventListener("input", function(event) {
            const emailInput = event.target.closest("#bis-email");
            if(!emailInput) return;
            
            emailInput.classList.remove("bis-invalid");
        });

        document.addEventListener("click", function(event) {
            const button = event.target.closest(".snize-oos-button");
            if(!button) return;

            event.preventDefault();
            event.stopPropagation();

            const modal = document.getElementById("back-in-stock");
            if(modal) modal.open(button);

            const productLink = button.closest("a");
            if(!productLink) return;

            fetch(`${productLink}.json`)
                .then(response => response.json())
                .then(product => {
                    const variantId = product.product.variants?.[0]?.id;
                    if(!variantId) return;
                    
                    modal.querySelector("#bis-variant-id").value = variantId;
           }).catch(error => console.error("Failed to get variant:", error));
        });
    }

    document.addEventListener("DOMContentLoaded", bindEvents);
})();